<template>
  <div class="device_cb_icon cb_icon">
    <div class="cb_icon" @click="lineName">
      <span class="iconfont icon-xianlugaiming"></span>
      <p>线路更名</p>
    </div>
    <div class="cb_icon" @click="lineRouteControl('lineOpen')" v-if="this.selectedLine != null && detail != null">
      <span class="iconfont icon-tiaozha1" v-if="selectedLine.switchStatus == 1"></span>
      <span class="iconfont icon-hezha" v-else></span>
      <p v-if="selectedLine.switchStatus == 1">跳闸</p>
      <p v-else>合闸</p>
    </div>
    <div class="cb_icon" @click="lineRouteControl('lineOpen')" v-else>
      <span class="iconfont icon-hezha"></span>
      <p>合闸</p>
    </div>
    <div class="cb_icon" @click="closingCommandBoth">
      <span class="iconfont icon-hezha"></span>
      <p>全部合闸</p>
    </div>
    <div class="cb_icon" @click="closingBoth">
      <span class="iconfont icon-tiaozha1"></span>
      <p>全部跳闸</p>
    </div>
    <div class="cb_icon"  @click="timingControl">
      <span class="iconfont icon-guoyaqianya"></span>
      <p>过压</p>
    </div>
    <div class="cb_icon"  @click="timingControl1">
      <span class="iconfont icon-guoyaqianya"></span>
      <p>欠压</p>
    </div>
    <div class="cb_icon" @click="updateLineName1">
      <span class="iconfont icon-guozaidianliu"></span>
      <p>过载电流</p>
    </div>
    <div  class="cb_icon" @click="currentAlm">
      <span class="iconfont icon-loudian"></span>
      <p>漏电阈值修改</p>
    </div>
    <div  class="cb_icon" @click="lineRouteControl('checkSelf')">
      <span class="iconfont icon-loudianzijian"></span>
      <p>漏电自检</p>
    </div>
    <!-- <div class="air_icon" @click="setPower1">
         <span class="iconfont icon-loudianzijian1"></span>
         <p>过载电流时间</p>
    </div>
      <div class="air_icon" @click="unlockManual" v-if="this.selectedLine != null && historyDetail.deviceCbList != null">
          <span class="iconfont icon-shoudongsuoding" ></span>
          <p v-if="selectedLine.lockManual == 1">使能手动锁定</p>
          <p v-else>解除手动锁定</p>
      </div> -->
    <!-- <div class="air_icon" @click="unlockManual" v-else>
        <span class="iconfont icon-shoudongsuoding"></span>
        <p>使能手动锁定</p>
    </div> -->
    <div class="cb_icon" @click="readData">
      <span class="iconfont icon-duqushuju"></span>
      <p>读取数据</p>
    </div>
    <div class="cb_icon" @click="readParameters">
      <span class="iconfont icon-canshu"></span>
      <p>读取参数</p>
    </div>
  </div>


</template>

<script>
export default {
  name: "base-cb-control"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/component/base-cb-control.vue